export default __webpack_public_path__ + "./fonts/x-symbol-svgrepo-com.f5457199.svg";